import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Entities } from 'src/app/core/models/globals';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-user-left-panel',
  templateUrl: './user-left-panel.component.html',
  styleUrls: ['./user-left-panel.component.scss'],
})
export class UserLeftPanelComponent implements OnInit {
  properties = [
    {
      name: 'Users',
      routerLink: 'Users',
      spanClass: 'bi bi-people',
    },
    {
      name: 'Groups',
      routerLink: 'Groups',
      spanClass: 'bi bi-collection',
    },
    {
      name: 'User Mapping',
      routerLink: 'UserMapping',
      spanClass: 'bi bi-collection'
    },
    {
      name: 'Logs',
      routerLink: 'Logs',
      spanClass: 'bi bi-body-text',
    },
  ];

  constructor(private navService: NavigationService) {}

  ngOnInit(): void {
    this.navService.sendParentData(Entities.Users);
    this.navService.selectedLogType = "User";
  }
}
